import styled from 'styled-components';

export const TabPillsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  background-color: transparent;
  border-radius: 40px;
  border: 1px solid #D6DCE5;
  padding: 4px;
  width: 100%;
  gap: 8px;
  margin-bottom: 16px;
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const TabPill = styled.button<{ isActive: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 40px;
  border: none;
  background-color: ${({ isActive }) => (isActive ? "#FFFFFF" : "transparent")};
  box-shadow: ${({ isActive }) => (isActive ? "0px 2px 8px rgba(0, 0, 0, 0.1)" : "none")};
  color: ${({ isActive }) => (isActive ? "#0A5CC7" : "#0A1F44")};
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-height: 52px;

  
  &:focus-visible {
    outline: 3px solid var(--Light-theme-buttons-all-focus-all, rgba(117, 172, 255, 0.50));
    outline-offset: 1px;
    transition: outline 0s, outline-offset 0s;
  }

  &:hover {
    background-color: ${({ isActive }) => (isActive ? "#FFFFFF" : "rgba(255,255,255,0.4)")};
  }

  svg, i, span.material-icons {
    font-size: 24px;
    flex-shrink: 0;
    color: #0A5CC7
  }
  
  @media (max-width: 768px) {
    flex-basis: calc(50% - 4px);
    border: 1px solid #D6DCE5;
  }
`;

export const DropdownContainer = styled.div`
  display: none;
  position: relative;
  width: 100%;
  font-family: Avenir, sans-serif;

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const DropdownHeader = styled.div<{ isOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border: 1px solid ${({ isOpen }) => (isOpen ? '#0A5CC7' : '#D6DCE5')};
  border-radius: 4px;
  background-color: #FFFFFF;
  font-size: 16px;
  font-weight: 800;
  color: #0A1F44;
  cursor: pointer;

  svg, i, span.material-icons {
    color: #0A5CC7;
    font-size: 24px;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.2s ease;
  }
`;

export const DropdownList = styled.div`
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  width: 100%;
  background-color: #FFFFFF;
  border: 1px solid #D6DCE5;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  z-index: 10;
  max-height: 250px;
  overflow-y: auto;
`;

export const DropdownItem = styled.div<{ isActive: boolean }>`
  padding: 16px 24px;
  font-size: 16px;
  font-weight: ${({ isActive }) => (isActive ? 800 : 400)};
  color: #0A1F44;
  cursor: pointer;
  background-color: ${({ isActive }) => (isActive ? '#F4F6F9' : '#FFFFFF')};

  &:hover {
    background-color: #F4F6F9;
  }
`;
